/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_GithubInputs */

const id_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ms_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const da_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const de_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const en_us2_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_es2_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_mx2_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fil_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fr_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const it_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const hu_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const nl_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const no_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pl_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_br2_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ro_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fi_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHubissa`)
};

const sv_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const vi_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const tr_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const cs_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const bg_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ru_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const uk_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ar_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const hi_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub पर`)
};

const th_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ja_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_cn2_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_hant1_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ko_privacy_github = /** @type {(inputs: Privacy_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {Privacy_GithubInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_github = /** @type {((inputs?: Privacy_GithubInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_GithubInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_github(inputs)
	if (locale === "ms") return ms_privacy_github(inputs)
	if (locale === "da") return da_privacy_github(inputs)
	if (locale === "de") return de_privacy_github(inputs)
	if (locale === "en-US") return en_us2_privacy_github(inputs)
	if (locale === "es-ES") return es_es2_privacy_github(inputs)
	if (locale === "es-MX") return es_mx2_privacy_github(inputs)
	if (locale === "fil") return fil_privacy_github(inputs)
	if (locale === "fr") return fr_privacy_github(inputs)
	if (locale === "it") return it_privacy_github(inputs)
	if (locale === "hu") return hu_privacy_github(inputs)
	if (locale === "nl") return nl_privacy_github(inputs)
	if (locale === "no") return no_privacy_github(inputs)
	if (locale === "pl") return pl_privacy_github(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_github(inputs)
	if (locale === "pt") return pt_privacy_github(inputs)
	if (locale === "ro") return ro_privacy_github(inputs)
	if (locale === "fi") return fi_privacy_github(inputs)
	if (locale === "sv") return sv_privacy_github(inputs)
	if (locale === "vi") return vi_privacy_github(inputs)
	if (locale === "tr") return tr_privacy_github(inputs)
	if (locale === "cs") return cs_privacy_github(inputs)
	if (locale === "bg") return bg_privacy_github(inputs)
	if (locale === "ru") return ru_privacy_github(inputs)
	if (locale === "uk") return uk_privacy_github(inputs)
	if (locale === "ar") return ar_privacy_github(inputs)
	if (locale === "hi") return hi_privacy_github(inputs)
	if (locale === "th") return th_privacy_github(inputs)
	if (locale === "ja") return ja_privacy_github(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_github(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_github(inputs)
	return ko_privacy_github(inputs)
});
export { privacy_github as "privacy.github" }